import { render, staticRenderFns } from "./GetGasSwapButtonTooltipContent.vue?vue&type=template&id=6877cd59&scoped=true"
import script from "./GetGasSwapButtonTooltipContent.vue?vue&type=script&lang=ts"
export * from "./GetGasSwapButtonTooltipContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6877cd59",
  null
  
)

export default component.exports